import { ValidationResultBase } from "./validation-result.model";

export class ValidationSectionBase {
    
	sectionId!:number;
    validationResult!:{ok:boolean,entity:ValidationResultBase,messageCode:string};

    static from(entity: ValidationSection): ValidationSectionBase {

        let current = new ValidationSectionBase();
        Object.assign(current, entity)    
        if (entity.validationResult.ok){
            current.validationResult.entity =  ValidationResultBase.from(entity.validationResult.entity)          
        }
        
        return current;
    }
}

export interface ValidationSection extends ValidationSectionBase {

}



